module.exports = __webpack_public_path__ + "static/media/FrankRuhlLibre_300Light.9236db54.ttf";